// eslint-disable-next-line import/no-extraneous-dependencies
import Notification from 'stimulus-notification';

export default class extends Notification {
  connect() {
    super.connect();
  }
}
